/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import HUDViewCss from "components/hud/HUDView.css";
import * as constants from "constants/constants";
import CustomIcon from "dc-preview-utils/src/components/CustomIcon";

class PrintButton extends Component {
  constructor(props) {
    super(props);
    this.handlePrintClick = this.handlePrintClick.bind(this);
  }

  handlePrintClick() {
    this.props.onClick();
  }

  render() {
    return !this.props.showPrintInTopBar ? (
      <div className={HUDViewCss.PrintButton}>
        <ButtonWrapper
          icon={this.props.icon}
          clickHandler={this.handlePrintClick}
          ariaLabel="arialabel.print"
          tooltipString="tooltip.print"
          tooltipPlacement={this.props.tooltipPlacement}
          tooltipDelay={this.props.tooltipDelay}
        />
      </div>
    ) : (
      <CustomIcon url={this.props.icon} />
    );
  }
}

export { PrintButton };
